import { render } from "./EmailVerification.vue?vue&type=template&id=64f716fe"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"

import "./EmailVerification.vue?vue&type=style&index=0&id=64f716fe&lang=css"
script.render = render

export default script